export default "__VITE_ASSET__BrqBxAfg__"